import BaseService from "src/packages/BaseService";

export default class AreaService extends BaseService {
	static get className() {
		return "area";
	}
};
